import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import { sendOptOutRequest } from "../api/requests";
import { Consent } from "../common/GeneralClasses";
import { buildThankYouUrl } from "../views/ThankYou";
import Button from "./Button";

interface OptOutButtonProps {
  buttonLabel: string;
  thankYouLabel: string;
  errorMessage: string;
  optOutState: Consent[];
  confirmButtonLabel: string;
  confirmButtonUrl: string;
}

export default function OptOutButton(props: OptOutButtonProps) {
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const onClickHandler = () => {
    const queryParams = new QueryParameters();
    setShowErrorMessage(false);
    setLoading(true);

    sendOptOutRequest(queryParams, props.optOutState)
      .then((status) => {
        if (status) {
          navigate(buildThankYouUrl(queryParams), {
            state: {
              label: props.thankYouLabel,
              buttonLabel: props.confirmButtonLabel,
              buttonUrl: props.confirmButtonUrl
            }
          });
        } else {
          setShowErrorMessage(true);
        }
      })
      .catch(() => {
        setShowErrorMessage(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      buttonLabel={props.buttonLabel}
      errorMessage={props.errorMessage}
      onClick={onClickHandler}
      isLoading={isLoading}
      showErrorMessage={showErrorMessage}
    />
  );
}
